export default "__VITE_ASSET__DgG6QcZI__"